import { useState } from 'react';
import { getDynamicEnvVarsInClient } from '@/utils/envHelper';
import axios from 'axios';
import { toast } from 'sonner';

const useEmailCheck = ({
  REQUEST_FROM_SIGNUP,
}: {
  REQUEST_FROM_SIGNUP?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{
    email: string;
    signUpWith: string;
    isUserInSameTenant: boolean;
    isPasswordEnabled: boolean | undefined;
    isOtpEnable: boolean;
    shakey: string;
  } | null>(null);
  const [error, setError] = useState<string>('');

  const { NEXT_PUBLIC_API_URL } = getDynamicEnvVarsInClient();

  const handleClick = async (
    email: string,
    tenantId: string,
    app_id?: string
  ) => {
    if (email) {
      setError('');
      setData(null);
      setLoading(true);
      try {
        const url = NEXT_PUBLIC_API_URL;
        const res = await axios.post(`${url}/email/check`, {
          email: email.toLowerCase(),
          tenantId,
          request_from_signup: !!REQUEST_FROM_SIGNUP,
          ...(app_id && { app_id }),
        });
        if (res.data) {
          setData(res.data);
        }
      } catch (error: any) {
        const axiosError = error;
        if (axiosError?.response) {
          setError(axiosError?.response?.data?.message || 'An error occurred');
        } else if (axiosError?.request) {
          setError('Request failed, please try again later');
        } else {
          setError('An error occurred, please try again later');
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Email required');
    }
  };

  return {
    loading,
    handleClick,
    data,
    error,
  };
};

export default useEmailCheck;
